<div class="moved-invoice-dialog">
  <div class="moved-invoice-dialog-header flex-between-center">
    <p class="m-0 font-bold">Move invoices to new statement</p>
    <span class="close-modal">
      <i class="fal fa-times" (click)="handleClose()"></i>
    </span>
  </div>

  <div class="moved-invoice-dialog-body flex-column flex-start-start">
    <p class="mb-1">{{invoices?.length}} invoice is already on statement and will be moved to this new statement.</p>
    <div class="moved-invoice-t-header width-100p flex-start-center">
      <p class="font-bold m-0 pt-1 pb-1">Invoice #</p>
      <p class="font-bold m-0 pt-1 pb-1">Current statement</p>
    </div>

    <div class="moved-invoice-t-row width-100p flex-start-center" *ngFor="let invoice of invoices">
      <p class="m-0 pt-1 pb-1">{{invoice?.invCode}}</p>
      <p class="m-0 pt-1 pb-1">{{invoice?.statementName}}</p>
    </div>
  </div>

  <div class="moved-invoice-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" (click)="handleMove(false)">
      Do not move
    </button>

    <button class="btn btn-primary btn-submit" (click)="handleMove(true)">
      Move
    </button>
  </div>
</div>
